/**
 * Frontend module registry entry point.
 * Every module file self-registers via `registerModule(id, { page, widgets })`.
 *
 * Module page components are lazy-loaded: `registerModule` runs synchronously
 * so the sidebar/nav still knows what exists, but the actual page bundle isn't
 * downloaded until the user navigates to that module.
 */
import { lazy } from "react";
import { registerModule } from "@/core/ModuleRegistry";

const InventoryPage = lazy(() => import("@/pages/app/InventoryPage"));
const AdaptivePOS = lazy(() => import("@/pages/app/AdaptivePOS"));
const SalesPage = lazy(() => import("@/pages/app/SalesPage"));
const InvoicesPage = lazy(() => import("@/pages/app/InvoicesPage"));
const CustomersPage = lazy(() => import("@/pages/app/CustomersPage"));
const AIAssistantPage = lazy(() => import("@/pages/app/AIAssistantPage"));

const CRMDealsPage = lazy(() => import("@/modules/crm/DealsPage"));
const WarehousePage = lazy(() => import("@/modules/warehouse/WarehousePage"));
const HRPage = lazy(() => import("@/modules/hr/HRPage"));
const BookingPage = lazy(() => import("@/modules/booking/BookingPage"));
const RestaurantPage = lazy(() => import("@/modules/restaurant/RestaurantPage"));
const HotelPage = lazy(() => import("@/modules/hotel/HotelPage"));
const ManufacturingPage = lazy(() => import("@/modules/manufacturing/ManufacturingPage"));
const AutomotivePage = lazy(() => import("@/modules/automotive/AutomotivePage"));
const PayrollPage = lazy(() => import("@/modules/payroll/PayrollPage"));

registerModule("inventory", { pages: { "/app/inventory": InventoryPage } });
registerModule("sales", { pages: { "/app/pos": AdaptivePOS, "/app/sales": SalesPage } });
registerModule("invoice", { pages: { "/app/invoices": InvoicesPage } });
registerModule("crm", { pages: { "/app/customers": CustomersPage, "/app/crm/deals": CRMDealsPage } });
registerModule("ai_assistant", { pages: { "/app/ai": AIAssistantPage } });
registerModule("warehouse", { pages: { "/app/warehouse": WarehousePage } });
registerModule("hr", { pages: { "/app/hr": HRPage } });
registerModule("booking", { pages: { "/app/booking": BookingPage } });
registerModule("restaurant", { pages: { "/app/restaurant": RestaurantPage } });
registerModule("hotel", { pages: { "/app/hotel": HotelPage } });
registerModule("manufacturing", { pages: { "/app/manufacturing": ManufacturingPage } });
registerModule("automotive", { pages: { "/app/automotive": AutomotivePage } });
registerModule("payroll", { pages: { "/app/payroll": PayrollPage } });
